/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";

const OPEN_STYLE = "feed-sidebar--open";

export default baustein.register("feed-sidebar", {
    /**
     * Displays the feed sidebar to the user. This only affects the mobile and tablet views.
     * @returns {Promise} a resolved promise.
     */
    show() {
        this.el.classList.add(OPEN_STYLE);
        this.emit("overlayOpen");
        return Promise.resolve();
    },

    /**
     * Closes the feed sidebar. This only affects the mobile and tablet views.
     * @returns {Promise} a resolved promise.
     */
    close() {
        this.el.classList.remove(OPEN_STYLE);
        this.emit("overlayClose");
        return Promise.resolve();
    },

    /**
     * Returns true if the sidebar is open, false otherwise.
     * @returns {boolean}
     */
    isOpen() {
        return this.el.classList.contains(OPEN_STYLE);
    }
});

